import type { ComponentProps } from "react"
import { QueryProvider } from "@/app/providers/QueryProvider"
import { ThemeProvider } from "@/app/providers/ThemeProvider"
import { RouterProvider } from "react-router"
import { ToastContainer } from "@/shadcn/components/ui/toast"
import { TooltipProvider } from "@/shadcn/components/ui/tooltip"
import { DialogContainer } from "@/shared/components/dialog"
import { MockServerIndicator } from "@/processes/mock-server"

type AppProps = {
  router: ComponentProps<typeof RouterProvider>["router"]
}

export function App({ router }: AppProps) {
  return (
    <QueryProvider>
      <ThemeProvider>
        <TooltipProvider>
          <RouterProvider router={router} />
          <DialogContainer />
          <MockServerIndicator />
          <ToastContainer />
        </TooltipProvider>
      </ThemeProvider>
    </QueryProvider>
  )
}

export default App
